import { accountActions } from 'core/Account';
import { config } from 'config';
import { connectSocket } from 'core/socket.root';
import moment from 'moment';
import orderBy from 'lodash/orderBy';
import { professionalActions } from 'core/Professional';
import {
    call,
    delay,
    put,
    select,
    take,
    takeEvery,
    takeLatest
} from 'redux-saga/effects';
import {
    dashboardActions,
    parseDoctors
} from './';
import dashboardServices, {
    socketService
} from './services';
const {
    professionalStatus,
    socketPrefix
} = config;

function* _getDashboardCalls ({ payload }) {
    try {
        yield put(dashboardActions.setDashboardCallsLoading(true));
        const { data: pageData } = yield call(dashboardServices.getCallsListPage, null, payload);
        yield put(dashboardActions.setDashboardCallsPage({
            ...pageData,
            filters: payload
        }));
    } catch (e) {
        
    } finally {
        yield put(dashboardActions.setDashboardCallsLoading(false));
    }
}

function* _getDashboardProfessionals ({ payload }) {
    try {
        yield put(dashboardActions.setDashboardProfessionalsLoading(true));
        const { filter } = payload ?? {};
        const filters = {
            ...payload,
            ...(professionalStatus ? { order_by: 'status' } : { order_by: 'last_name' }),
            ...(filter && { status: filter }),
            summarized: 1
        };
        const { data: pageData } = yield call(dashboardServices.getProfessionalsList, null, filters);
        yield put(dashboardActions.setDashboardProfessionalsPage({
            ...pageData,
            filters
        }));
    } catch (e) {
        
    } finally {
        yield put(dashboardActions.setDashboardProfessionalsLoading(false));
    }
}

function* _getDashboardTracking ({ payload: call_id }) {
    try {
        const { data: { call_behaviors, ratings, reference, session, traceabilities, twilio_behaviors } } = yield call(dashboardServices.getCallTracking, { call_id });
        yield put(dashboardActions.setDashboardTracking({
            call_behaviors,
            call_id,
            display: true,
            ratings,
            reference,
            session,
            traceabilities: orderBy(traceabilities, ['created_at']),
            twilio_behaviors
        }));
    } catch (e) {}
}

function* _handleSocketEvent ({ payload: { call, call: { call_id: callId }, doctors = [], type } }) {
    try {

        const { dashboard: { callsPage, professionalsPage }, professional: { list: professionalList } } = yield select();

        if (professionalStatus) {
            if (!!professionalsPage && !!doctors.find(({ id }) => !!id)) {
                professionalsPage.getFirstPage();
            }
            doctors.forEach(({ id: doctorId, status }) => {
                const professionalOfList = professionalList.find(({ id }) => id === doctorId);
                if (!!professionalOfList) {
                    professionalOfList.status = status;
                }
            });
            yield put(professionalActions.setProfessionalList(professionalList));
        }

        if (callId && callId !== 0) {
            if (type === 'Update' && !!callsPage) {
                const updatedCall = callsPage.findItem('call_id', callId);
                if (!!updatedCall) {
                    parseDoctors(call);
                    callsPage.replaceItem('call_id', callId, call);
                    yield put(dashboardActions.setDashboardCallsRender(moment().valueOf()));
                }
            } else if (type === 'Create') {
                yield delay(1500);
                yield put(dashboardActions.setDashboardRefreshCalls(true));
            }
        }
    } catch (e) {

    }
}

function* _setDashboardSockets () {
    const session = localStorage.getItem('sessionData');
    if (!!session) {
        const userId = JSON.parse(session)?.user?.id;
        if (!userId) return;
        const { account: { socket: existingSocket } } = yield select();
        const socket = !!existingSocket && existingSocket.connected ? existingSocket : yield call(connectSocket);
        if (!existingSocket || !existingSocket.connected) {
            yield put(accountActions.setAccountSocket(socket));
            socket.emit('subscribe', { channel: `${ socketPrefix }-channel-admin-${ userId }` });
            const channel = yield call(socketService, socket);
            while (true) {
                const action = yield take(channel);
                yield put(action);
            }
        }
    }
}

export default [
    takeLatest(dashboardActions.getDashboardCalls.type, _getDashboardCalls),
    takeEvery(dashboardActions.getDashboardProfessionals.type, _getDashboardProfessionals),
    takeEvery(dashboardActions.getDashboardTracking.type, _getDashboardTracking),
    takeEvery(dashboardActions.handleSocketEvent.type, _handleSocketEvent),
    takeEvery(dashboardActions.setDashboardSockets.type, _setDashboardSockets)
];
